import { useEffect } from "react";
import { createPortal } from "react-dom";

const Portal = ({children=()=>{}, className=''}) => {
  const mount = document.getElementById("portal-root");
  const el = document.createElement("div");
  mount.classList.add(className.split(" "));

  useEffect(() => {
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el, mount]);

  return createPortal(children, el)
};

export default Portal;